import { useShouldHideIntercom } from '#app/components/Intercom/Intercom.js';
import { useCurrentUser } from '#app/hooks/useCurrentUser.js';
import { lazy, Suspense } from 'react';

const LazyLoadedIntercom = lazy(async () => {
  return {
    default: (await import('#app/components/Intercom/Intercom.js')).Intercom,
  };
});

export const LazyIntercomWrapper = () => {
  const currentUser = useCurrentUser();

  const { shouldHide } = useShouldHideIntercom();

  return currentUser &&
    currentUser.selectedUserType === 'CONTRACTOR' &&
    !shouldHide ? (
    <Suspense>
      <LazyLoadedIntercom />
    </Suspense>
  ) : null;
};
